import { n as e } from "./id-Cl4PImxR.js";
//#region src/helpers/prepareConfiguration.ts
var t = (t, n = !1) => {
	if (!t?.collectorSettings?.connections) return t;
	let r = t.collectorSettings.connections.map((t) => {
		let n = t?.tags?.map((e) => e?.name === "loggerIdentifier" || e?.name === "loggerActivationUid" ? {
			...e,
			preventDeleting: !0,
			preventNameEditing: !0
		} : e);
		if (!t?.measurements) return {
			...t,
			tags: n
		};
		let r = t.measurements.map((t) => {
			if (!t?.variables) return t;
			let n = t.variables.map((t) => t?.id ? t : {
				...t,
				id: e()
			});
			return {
				...t,
				variables: n
			};
		});
		return {
			...t,
			measurements: r,
			tags: n
		};
	});
	return {
		...t,
		collectorSettings: {
			...t.collectorSettings,
			connections: r,
			triggers: n ? t.collectorSettings.triggers : null
		}
	};
};
//#endregion
export { t };

//# sourceMappingURL=prepareConfiguration-DbRyekyU.js.map